<template>
  <div 
    class="form-section-header-title"
    :class="{ 'form-section-tab-selected': tab.selected }"
    @click="$emit('tab:click')"
  >
    {{tab.header || 'Tab'}}
    <font-awesome-icon :icon="['fas', 'exclamation']" class="form-section-header-error-icon" v-if="isValidationError" />
  </div>
</template>

<script>
export default {
  props: {
    tab: Object,
    validator: Object
  },
  computed: {
    isValidationError() {
      if (
        this.tab.design && 
        Array.isArray(this.tab.design.rows) && 
        this.validator
      ) {
        const findElement = (elements) => {
          return elements.some(x => {
            if (x.tabs) {
              return findElement(x.tabs);
            } else if (x.design && x.design.rows) {
              return findElement(x.design.rows);
            } else if (x.items) {
              return findElement(x.items);
            }

            return this.validator[x.fieldName] && this.validator[x.fieldName].$error === true;
          });
        }

        return findElement(this.tab.design.rows);
      }

      return false;
    }
  }
}
</script>